__turbopack_context__.v({
  "className": "marcellus_bd8d94d0-module__Cxfpkq__className",
  "variable": "marcellus_bd8d94d0-module__Cxfpkq__variable",
});
